import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=9a36f93e&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\HK198Mall\\webim-vue-demo-demo-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a36f93e"]])

export default __exports__